import { useState, useEffect, useRef } from "react";
import { Toaster, toast} from "react-hot-toast";
import { useLocation, useParams } from 'react-router-dom';
import Select from "react-select";
import { Select as MuiSelect } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
import { Tab, Box, Button, Paper, Stack, IconButton, TextField, Grid, MenuItem, FormControl, InputLabel, Snackbar} from "@mui/material";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow,Tooltip } from '@mui/material';
import TabContext from "@mui/lab/TabContext";
import { keyframes } from '@mui/system';
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import CircularProgress from "@mui/material/CircularProgress";
import Switch from "@mui/material/Switch";
import { useMediaQuery } from "react-responsive";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { FaBackspace} from "react-icons/fa";
import { Title } from "../../components/atoms";
import { BiLoaderCircle } from "react-icons/bi";
import { CheckCircle, Cancel } from '@mui/icons-material';
import {getUserPreference, getWooCommerceAuthLink, 
  getWooCommerceUploadStatus, getProductCategories, 
  updateWooProductCategoryMap, updateWooPriceSyncPreference, 
  getShopifyAppLink, getShopifyUploadStatus,
  updateShopifyPricePreference,  updateShopifyCategoryMap,
  updateShopifyProductMap} from "../../api/api";

const ThirdPartyIntegration = () =>{
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 900px)' })
    const [isLoading, setIsLoading] = useState(false);
    const [wooConnected, setWooConnected] = useState(false);
    const [value, setValue] = useState(1);
    
    const tabs = [
      { id: 1, name: "WooCommerce" },
      {id:2, name: "Shopify"},
      
    ];

    const location = useLocation();

    useEffect(async () => {
    
    setIsLoading(true);
    const searchParams = new URLSearchParams(location.search);
    const tab = searchParams.get("tab");
    console.log("tab", tab);
    if(tab === "shopify"){
      setValue(2);
    }

     var response = await getUserPreference();
     console.log("woo connected ",response.data.isWooConnected);
     setWooConnected(response.data.isWooConnected);
     setIsLoading(false);

      }, []);

      

      const handleChange = (event, newValue) => {
        setValue(newValue);
      };


    return (
        <div className="tabPanelCls">
          <Toaster />
    
          <div className="dispatchTimer" style={{ position: "relative" }}>
            <div style={{ width: "100%", background: "white" }}>
              <div className="header fixed">
              <Stack style={{paddingTop:'5px'}} direction={{xs: 'column', md: 'row'}} spacing={3} >
                    <h2 style={{display:'flex'}}>
                      <IconButton>
                      <a className={'j'} style={{textDecoration:'none',color:'red'}} href={'/Settings'}><FaBackspace/></a>
                    </IconButton>Third Party Integrations</h2>
                   
               </Stack>
              </div>
            </div>
    
            <Box
              style={{ marginTop: "35px" }}
              sx={{ width: "100%", typography: "body1" }}
            >
              <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <TabList
                    style={{ borderBottom: "solid 3px red" }}
                    className="fixed"
                    onChange={handleChange}
                  >
                    {tabs.map((d) => {
                      return (
                        <Tab
                          key={d.id}
                          sx={{ fontSize: "16px", fontWeight: "600" }}
                          label={d.name}
                          value={d.id}
                        />
                      );
                    })}
                  </TabList>
                </Box>
                <TabPanel value={1} style={{ marginTop: "60px" }}>
                  {WooCommerceView(wooConnected)}
                </TabPanel>
                <TabPanel value={2} style={{ marginTop: "60px" }}>
                  {ShopifyView(wooConnected)}
                </TabPanel>
               
              </TabContext>
            </Box>
          </div>
        </div>
      );
      
      function WooCommerceView(wooConnected) {
        const [storeUrl, setStoreUrl] = useState(null);
        const [loading, setLoading] = useState(false);
        const [buttonLoading, setButtonLoading] = useState(false);
        const [categoryMap, setCategoryMap] = useState([]);
        const [hasUnMatchedCategory, setHasUnMatchedCategory] = useState(false);
        const [productCategories, setProductCategories] = useState([]);
        const [reconsileCategoryView, setReconsileCategoryView] = useState(false);
        const [syncPrice, setSyncPrice] = useState(true);
      

        const location = useLocation();
        const queryParams = new URLSearchParams(location.search);
        const success = queryParams.get('success');

        const [isWooCommerceConnected, setIsWooCommerceConnected] = useState(success == 1?true:false || wooConnected);
        
        useEffect(async () => {
        
          setLoading(true);
          var response = await getWooCommerceUploadStatus();
          console.log("----- response-----",response);
          if(response)
          {
            setIsWooCommerceConnected(response.isWooConnected);
            setHasUnMatchedCategory(response.hasUnmatchedCategory);
            setCategoryMap(response.unmatchedCategory);
            setSyncPrice(response.syncPrice);
          }
          setLoading(false);

          var result = await getProductCategories();
           const { data } = result;
        const prodCat =
        data &&
        data.map((m) => ({
            value: m.id,
            label: m.name,
        }));

        setProductCategories(prodCat);
     // setCategoryMap([{"WooCommerceCategoryName":"Sport Shoe","TCSCategoryName":null,"isSet":false,"isProductUpdated":false},{"WooCommerceCategoryName":"Woo Gloves","TCSCategoryName":null,"isSet":false,"isProductUpdated":false}, {"WooCommerceCategoryName":"Woo Gloves","TCSCategoryName":null,"isSet":false,"isProductUpdated":false}, {"WooCommerceCategoryName":"Woo Gloves","TCSCategoryName":null,"isSet":false,"isProductUpdated":false}, {"wooCommerceCategoryName":"Woo Gloves","TCSCategoryName":null,"isSet":false,"isProductUpdated":false}]);
            }, []);
            useEffect(async () => {
        
              setLoading(true);
              var response = await getWooCommerceUploadStatus();
              
              if(response)
              {
                setIsWooCommerceConnected(response.isWooConnected);
                setHasUnMatchedCategory(response.hasUnmatchedCategory);
                setCategoryMap(response.unmatchedCategory);
                setSyncPrice(response.syncPrice);

                
              }
              setLoading(false);
    
              var result = await getProductCategories();
               const { data } = result;
            const prodCat =
            data &&
            data.map((m) => ({
                value: m.id,
                label: m.name,
            }));
    
            setProductCategories(prodCat);
          //setCategoryMap([{"WooCommerceCategoryName":"Sport Shoe","TCSCategoryName":null,"isSet":false,"isProductUpdated":false},{"WooCommerceCategoryName":"Woo Gloves","TCSCategoryName":null,"isSet":false,"isProductUpdated":false}, {"WooCommerceCategoryName":"Woo Gloves","TCSCategoryName":null,"isSet":false,"isProductUpdated":false}, {"WooCommerceCategoryName":"Woo Gloves","TCSCategoryName":null,"isSet":false,"isProductUpdated":false}, {"wooCommerceCategoryName":"Woo Gloves","TCSCategoryName":null,"isSet":false,"isProductUpdated":false}]);
                }, [reconsileCategoryView]);

        
        const handleUrlChange = (event) => {
            setStoreUrl(event.target.value);
        }
        const handleReconsilationView =()=>{
          setReconsileCategoryView(true);
        }
        const handleCancelReconsilation =()=>{
          setReconsileCategoryView(false);
        }
        const handleSelectedCategory =(option, index)=>{
            var categoryValue = option.label;
            const newList = [...categoryMap];
            newList[index].tcsCategoryName = categoryValue;
            newList[index].isSet = true;
            console.log(newList, "option---", option);
            setCategoryMap(newList, option);
        }
        const handleUpdateCategoryMap = async () =>{
          setLoading(true);
          try {
            
            setLoading(true);
            const response = await updateWooProductCategoryMap(
              JSON.stringify({
                data: categoryMap,
              })
            );
      
            if (response) {
              
      
            
                toast.success("Category updated successfully");
             
            } else {
              console.error("API call failed");
            }
          } catch (error) {
            
            toast.error("Could not complete request");
          } finally {
            setLoading(false);
          }

          setReconsileCategoryView(false);
        }
        const handleConnectWoo = async () =>{
          setButtonLoading(true);
            var response = await getWooCommerceAuthLink(storeUrl);
            setButtonLoading(false);
           
            window.open(
                response.url.result
              );

        }
        const handlePriceSyncSwitch = async ()=>{

          
          // var result = await updateWooPriceSyncPreference({syncPrice:status});

          // if(result)
          // {
          //   setSyncPrice(status);
          // }
          try {
            let targetValue = !syncPrice;
            setLoading(true);
            const response = await updateWooPriceSyncPreference(
              JSON.stringify({
                syncPrice: targetValue,
              })
            );
      
            if (response) {
              setSyncPrice(targetValue);
              
      
              if (targetValue) {
                toast.success("Your price sync preference has been set to keep price synced");
              } else {
                toast.success("Your price sync preference has been set to disable price synced");
              }
            } else {
              console.error("API call failed");
            }
          } catch (error) {
            
            toast.error("Could not complete request");
          } finally {
            setLoading(false);
          }

          
        }
        const unreconsiledText1 = "Our system has detected products that do not automatically fit into a category.";
        const unreconsiledText2 = "Please click the button below to reconcile these products with the correct categories.";
        return (
          <div>
            {isWooCommerceConnected ? (!reconsileCategoryView ? (<Paper
              className="center"
              style={{ marginTop: "20px", padding: "25px 50px 50px 50px" }}
            >
               
            <Stack direction={{xs: 'column', md: 'column'}} spacing={4} alignItems="center" justifyContent="center">
            <Grid>
               <CheckCircle style={{ color: '#23753D' }} />
                <Title text={"Woo Commerce connected"}/>
            </Grid>
            <Grid>
                <FormGroup>
                <FormControlLabel
                control={
                    loading ? (
                    <CircularProgress
                        style={{ marginRight: 10 }}
                        size={24}
                        color="secondary"
                    />
                    ) : (
                    <Switch
                        color="success"
                        checked={syncPrice}
                        onChange={handlePriceSyncSwitch}
                    />
                    )
                }
                label="Toggle price sync"
                style={{ marginLeft: 10, marginTop: 40 }}
                />
                </FormGroup>
               
            </Grid>
           
            {hasUnMatchedCategory && 
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
            <Grid container  style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }} spacing={4}>
             <Grid item style={{ textAlign: isTabletOrMobile ? 'justify' : 'center'}}>
                
              <Title className="black" text={unreconsiledText1} />
              <br></br>
              <Title className="black" text={unreconsiledText2}/>
              </Grid>
              <Grid item>
              <Button  variant="contained" onClick={handleReconsilationView}>Reconcile</Button>
              </Grid>
              
              </Grid>
              </div>}
            </Stack>
            </Paper>) : (<Paper
                className="center"
                style={{ marginTop: "40px", padding: "25px 50px 50px 50px" }}
              >
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                <div style={{ paddingBottom: '40px', textAlign:'center' }}>
                  <Title className={"bold"} text={"Select an option from the drop down to match each category"} />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                <Grid container spacing={3} >
                  {categoryMap.map((item, index) => (
                    <Grid item xs={12} md={6} alignItems="center" justifyContent="center" key={index}
                    style={{ textAlign: index === categoryMap.length - 1 && categoryMap.length % 2 !== 0 ? 'left' : 'center' }}
                    >
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                        <Title text={item.wooCommerceCategoryName} className={item.isSet ? '' : 'red'} />
                        <Select
                          style={{ fontWeight: 'normal', alignItems: "center", justifyContent:"center", width:'50%' }}
                          placeholder={"Please select matching category"}
                          onChange={(option) => handleSelectedCategory(option, index)}
                          options={productCategories}
                          defaultValue={item.tCSCategoryName}
                          isSearchable={false}
                        />
                      </div>
                    </Grid>
                  ))}
                </Grid>
                <Grid container spacing={3} justifyContent="center" style={{ marginTop: '20px' }}>
                  <Grid item>
                    <Button variant="contained" 
                    
                    onClick={handleCancelReconsilation}
                    sx={{ background: "black", color: "white" }}
                    >
                      Cancel
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button variant="contained" 
                    sx={{ background: "green", color: "white" }}
                    startIcon={loading && <CircularProgress
                      
                      size={15}
                      
                  />}
                  onClick={() =>handleUpdateCategoryMap()}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
                </div>

                </div>
              </Paper>

              )
            ) : 
            (<Paper
                className="center"
                style={{ marginTop: "50px", padding: "100px 50px" }}
              >
              <Stack direction={{xs: 'column', md: 'row'}} spacing={2} alignItems="center" justifyContent="center">
              <Grid>
                  <TextField
                  id="outlined-controlled"
                  label="Enter Store Url"
                  type="text"
                   defaultValue={storeUrl}
                     onChange={(e)=>handleUrlChange(e)}
              //   error={emailError}
                  //helperText={emailError ? "Enter a valid email address" : ""}
                  autoFocus 
                  />
              </Grid>
              <Grid>
                <Button
                  size="small"
                  onClick={() =>handleConnectWoo()}
                  startIcon={buttonLoading && <CircularProgress
                    style={{ }}
                    size={15}
                    color="secondary"
                />}
                  variant="contained"
                >
                  Connect WooCommerce
                </Button>
                </Grid>
                </Stack>
              </Paper>)}
          </div>
        );
      }
      function ShopifyView(shopifyConnected){
        const [shopifyStoreUrl, setShopifyStoreUrl] = useState(null);
        const [loading, setLoading] = useState(false);
        const [buttonLoading, setButtonLoading] = useState(false);
        const [categoryMap, setCategoryMap] = useState([]);
        const [hasUnMatchedCategory, setHasUnMatchedCategory] = useState(false);
        const [productCategories, setProductCategories] = useState([]);
        const [reconsileCategoryView, setReconsileCategoryView] = useState(false);
        const [syncPrice, setSyncPrice] = useState(true);
        const [reconsileProductView, setReconsileProductView] = useState(false);
        const [productMap, setProductMap] = useState([]);
        const [existingProducts, setExistingProducts] = useState([]);
        const [showPriceDisclaimer, setShowPriceDisclaimer] = useState(false);
        const [isShopifyConnected, setIsShopifyConnected] = useState(false);
        const defaultMatchOptions = [{id:"option1", title:"Create as new product on TCS"}, {id:"option2", title:"Exclude from TCS"}];
       

        useEffect(async () => {
        
          setLoading(true);
           var response = await getShopifyUploadStatus();
           
          if(response)
          {
            setIsShopifyConnected(response.isConnected);
            setHasUnMatchedCategory(response.hasUnmatchedCategory);
            setCategoryMap(response.unmatchedCategory);
            setSyncPrice(response.syncPrice);
            setProductMap(response.productMatch);

            const existingProduct = response.existingProducts;
            setExistingProducts([...defaultMatchOptions, ...existingProduct]);

          }
          // setCategoryMap([{"WooCommerceCategoryName":"Sport Shoe","TCSCategoryName":null,"isSet":false,"isProductUpdated":false},{"WooCommerceCategoryName":"Woo Gloves","TCSCategoryName":null,"isSet":false,"isProductUpdated":false}, {"WooCommerceCategoryName":"Woo Gloves","TCSCategoryName":null,"isSet":false,"isProductUpdated":false}, {"WooCommerceCategoryName":"Woo Gloves","TCSCategoryName":null,"isSet":false,"isProductUpdated":false}, {"wooCommerceCategoryName":"Woo Gloves","TCSCategoryName":null,"isSet":false,"isProductUpdated":false}]);

          // setProductMap([{id:"1", title:"Nonso Steel Toe Shoe", isMatched:false, existingProdId:null, existingProdTitle:null, create:false, exclude:false}, {id:"2", title:"Sample Product One One", isMatched:false, existingProdId:null, existingProdTitle:null, create:false, exclude:false}, {id:"6", title:"Sample Product One Two", isMatched:false, existingProdId:null, existingProdTitle:null, create:false, exclude:false}]);
          // setExistingProducts([{id:"option1", title:"Create as new product on TCS"}, {id:"option2", title:"Exclude from TCS"}, {id:"1", title:"Nonso Steel Toe"}, {id:"2", title:"Sample Product One"}, {id:"3", title:"Sample Product 3"}]);
          

          var result = await getProductCategories();
           const { data } = result;
        const prodCat =
        data &&
        data.map((m) => ({
            value: m.id,
            label: m.name,
        }));

        setProductCategories(prodCat);

        setLoading(false);
        setShowPriceDisclaimer(true);
     setTimeout(() => {
      setShowPriceDisclaimer(false);
    }, 60000); // 1 minute timer

    
     
            }, []);

            useEffect(async () => {
        
              setLoading(true);

              var response = await getShopifyUploadStatus();
              
             if(response)
             {
               setIsShopifyConnected(response.isConnected);
               setHasUnMatchedCategory(response.hasUnmatchedCategory);
               setCategoryMap(response.unmatchedCategory);
               setSyncPrice(response.syncPrice);
               setProductMap(response.productMatch);
               
               const existingProduct = response.existingProducts;
              setExistingProducts([...defaultMatchOptions, ...existingProduct]);
   
             }

             setLoading(false);

                }, [reconsileCategoryView]);

        
        const handleUrlChange = (event) => {
          setShopifyStoreUrl(event.target.value);
        }
        const handleReconsilationView =()=>{
          setReconsileCategoryView(true);
        }
        const handleCancelReconsilation =()=>{
          setReconsileCategoryView(false);
        }
        const handleSelectedCategory =(option, index)=> {
            var categoryValue = option.label;
            const newList = [...categoryMap];
            newList[index].tcsCategoryName = categoryValue;
            newList[index].isMatched = true;
           
            setCategoryMap(newList, option);
        }
        const handleSelectedProduct =(option, index)=> {
          var prodId = option.id;
          const newList = [...productMap];
          // newList[index].id = categoryValue;
          // newList[index].isSet = true;
         
         // setCategoryMap(newList, option);
      }
        const handleUpdateCategoryMap = async () =>{
         
          try {
            
            setLoading(true);
            const response = await updateShopifyCategoryMap(
              JSON.stringify({
                data: categoryMap,
              })
            );
      
            if (response) {
              
      
            
                toast.success("Category updated successfully");
             
            } else {
              console.error("API call failed");
            }
          } catch (error) {
            
            toast.error("Could not complete request");
          } finally {
            setLoading(false);
          }

          //setReconsileCategoryView(false);
          setReconsileProductView(true);
        }
        const dropDownBackgroundColor = (index) =>{
          if(index === 0)
          {
            return '#90EE90';
          }
          else if(index === 1){
            return '#C08081';
          }
          else{
            return '';
          }
        }
        const handleUpdateProductMap = async () =>{
         
          try {
            
            setLoading(true);
            const response = await updateShopifyProductMap(
              JSON.stringify({
                data: productMap,
              })
            );
      
            if (response) {
              
      
            
                toast.success("Products updated successfully");
             
            } else {
              console.error("API call failed");
            }
          } catch (error) {
            
            toast.error("Could not complete request");
          } finally {
            setLoading(false);
          }

          //setReconsileCategoryView(false);
          setLoading(false);
          setReconsileProductView(false);
          setReconsileCategoryView(false);
        }
        const handleConnectShopify = async () =>{
          setButtonLoading(true);
            var response = await getShopifyAppLink(shopifyStoreUrl);
           
            setButtonLoading(false);
           
            window.open(
                response
              );

        }
        const handlePriceSyncSwitch = async ()=>{

          
          
          try {
            let targetValue = !syncPrice;
            setLoading(true);
            const response = await updateShopifyPricePreference(
              JSON.stringify({
                syncPrice: targetValue,
              })
            );
      
            if (response) {
              setSyncPrice(targetValue);
              
      
              if (targetValue) {
                toast.success("Your price sync preference has been set to keep price synced");
              } else {
                toast.success("Your price sync preference has been set to disable price synced");
              }
            } else {
              console.error("API call failed");
            }
          } catch (error) {
            
            toast.error("Could not complete request");
          } finally {
            setLoading(false);
          }

          
        }
        const handleSelectedProductMatchOption = (prod, prodmatchId) => {
          
          
          if(prodmatchId === "option1"){

            const updatedProducts = productMap.map(product => 
              product.id === prod.id ? { ...product, existingProdId: null, existingProdTitle:"Create product on TCS", isMatched:true, create:true, exclude:false } : product
            )

            setProductMap(updatedProducts);
            return;
          }
          if(prodmatchId === "option2"){

            const updatedProducts = productMap.map(product => 
              product.id === prod.id ? { ...product, existingProdId: null, existingProdTitle:"Exclude from TCS", isMatched:true, create:false, exclude:true } : product
            )

            setProductMap(updatedProducts);
            return;
          }
          const existingProduct = existingProducts.find(product => product.id === prodmatchId);
          
          if(existingProduct != null){
            
            const updatedProducts = productMap.map(product => 
              product.id === prod.id ? { ...product, existingProdId: existingProduct.id, existingProdTitle:existingProduct.title, isMatched:true,  } : product
            )

            const updatedExistingProducts =   existingProducts.filter(product => product.id !== existingProduct.id);
            setProductMap(updatedProducts);
            setExistingProducts(updatedExistingProducts);
            
        }
        return;
        }
        const getStatusIcon = (status) => {
          switch (status) {
            case true:
              return <Tooltip title="Matched"><CheckCircle style={{ color: 'green' }} /></Tooltip>;
            
            case false:
              return <Tooltip title="Not Matched"><Cancel style={{ color: 'red' }} /></Tooltip>;
            default:
              return null;
          }
        };
        const unreconsiledText1 = "Our system has detected products that do not automatically fit into a category.";
        const unreconsiledText2 = "Please click the button below to reconcile these products with the correct categories.";
        return (
          <div>
            {isShopifyConnected ? 
            (!reconsileCategoryView ? 
              (<Paper
              className="center"
              style={{ marginTop: "20px", padding: "25px 50px 50px 50px" }}
            >
               
            <Stack direction={{xs: 'column', md: 'column'}} spacing={4} alignItems="center" justifyContent="center">
            <Grid>
               <CheckCircle style={{ color: '#23753D' }} />
                <Title text={"Shopify connected"}/>
            </Grid>
            <Grid style={{display:'flex', flexDirection: 'row'}}>
              <div>
                <FormGroup>
                <FormControlLabel
                control={
                    loading ? (
                    <CircularProgress
                        style={{ marginRight: 10 }}
                        size={24}
                        color="secondary"
                    />
                    ) : (
                    <Switch
                        color="success"
                        checked={syncPrice}
                        onChange={handlePriceSyncSwitch}
                    />
                    )
                }
                label="Toggle price sync"
                style={{ marginLeft: 10, marginTop: 40 }}
                />
                </FormGroup>
                </div>
                <div style={{marginTop: '38px'}}>
                <Tooltip title="Click to learn how price sync works.">
                  <IconButton  onClick={()=>{setShowPriceDisclaimer(true)}}>
                <InfoIcon />
                </IconButton>
                </Tooltip>
                <Snackbar
              open={showPriceDisclaimer}
              onClose={()=>{setShowPriceDisclaimer(false)}}
              message="Please note that toggling price sync automatically disables all merchant created top deal campaigns. Also if you create a campaign at a later date while price sync is on, our system automatically disables price sync."
              action={
                <IconButton size="small" color="inherit" onClick={()=>{setShowPriceDisclaimer(false)}}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              }
              anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
            />
            </div>
            </Grid>
            
            {hasUnMatchedCategory && 
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
            <Grid container  style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }} spacing={4}>
             <Grid item style={{ textAlign: isTabletOrMobile ? 'justify' : 'center'}}>
                
              <Title className="black" text={unreconsiledText1} />
              <br></br>
              <Title className="black" text={unreconsiledText2}/>
              </Grid>
              <Grid item>
              <Button  variant="contained" onClick={handleReconsilationView}>Reconcile</Button>
              </Grid>
              
              </Grid>
              </div>}
            </Stack>
            </Paper>) : 
            (!reconsileProductView ?
            (
              <Paper
                className="center"
                style={{ marginTop: "40px", padding: "25px 50px 50px 50px" }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                <div style={{ paddingBottom: '40px', textAlign:'center' }}>
                  <Title className={"bold"} text={"Select an option from the drop down to match each category"} />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                <Grid container spacing={3} >
                  {categoryMap.map((item, index) => (
                    <Grid item xs={12} md={6} alignItems="center" justifyContent="center" key={index}
                    style={{ textAlign: index === categoryMap.length - 1 && categoryMap.length % 2 !== 0 ? 'left' : 'center' }}
                    >
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                        <Title text={item.merchantCategoryName} className={item.isMatched ? '' : 'red'} />
                        <Select
                          style={{ fontWeight: 'normal', alignItems: "center", justifyContent:"center", width:'50%' }}
                          placeholder={"Please select matching category"}
                          onChange={(option) => handleSelectedCategory(option, index)}
                          options={productCategories}
                          defaultValue={item.tcsCategoryName}
                          isSearchable={false}
                        />
                      </div>
                    </Grid>
                  ))}
                </Grid>
                <Grid container spacing={3} justifyContent="center" style={{ marginTop: '20px' }}>
                  <Grid item>
                    <Button variant="contained" 
                    
                    onClick={handleCancelReconsilation}
                    sx={{ background: "black", color: "white" }}
                    >
                      Cancel
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button variant="contained" 
                    sx={{ background: "green", color: "white" }}
                    startIcon={loading && <CircularProgress
                      
                      size={15}
                      
                  />}
                  onClick={() =>handleUpdateCategoryMap()}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
                </div>

                </div>
              </Paper>
            )
            :
            (<Paper
              className="center"
              style={{ marginTop: "40px", padding: "25px 50px 50px 50px" }}>
              <div style={{ paddingBottom: '40px', textAlign:'center' }}>
                  <Title className={"bold"} text={"Select an option from the drop down to match each category"} />
                </div>
             <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="center"><b>Products from your Shopify store</b></TableCell>
            <TableCell align="center"><b>Status</b></TableCell>
            <TableCell align="center"><b>Match Options</b></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {productMap.map((product, index) => (
            <TableRow key={product.id}>
              {/* Store A Product */}
              <TableCell align="center">{product.title}</TableCell>
              
              {/* Match Indicator */}
              <TableCell align="center">
                {getStatusIcon(product.isMatched)}
              </TableCell>
              
              {/* Store B Product */}
              <TableCell  align="center">
                {product.existingProdTitle ? product.existingProdTitle 
                : <FormControl variant="outlined" size="small" style={{ minWidth: 200 }}>
                    <InputLabel>Select an option</InputLabel>
                    <MuiSelect
                      value={product.existingProdTitle}
                      onChange={(e) => {handleSelectedProductMatchOption(product, e.target.value)}}
                      label="Please select"
                    >
                      {existingProducts.map((m, index) => (
                        <MenuItem key={m.id} value={m.id} style={{backgroundColor: index === 0 ? '#DFF6DF' : index === 1 ? '#F8D3D3' : 'inherit', }}>
                          {m.title}
                        </MenuItem>
                      ))}
                    </MuiSelect>
                  </FormControl>}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    <div style={{ paddingTop: '40px', textAlign:'right' }}>
    <Button variant="contained" 
                    sx={{ background: "green", color: "white" }}
                    startIcon={loading && <CircularProgress
                      
                      size={15}
                      
                  />}
                  onClick={() =>handleUpdateProductMap()}
                    >
                      Proceed
                    </Button>
                </div>
            </Paper>)

              )
            ) : 
            (<Paper
                className="center"
                style={{ marginTop: "50px", padding: "100px 50px" }}
              >
              <Stack direction={{xs: 'column', md: 'row'}} spacing={2} alignItems="center" justifyContent="center">
              <Grid>
                  <TextField
                  id="outlined-controlled"
                  label="Enter Store Url"
                  type="text"
                   defaultValue={shopifyStoreUrl}
                     onChange={(e)=>handleUrlChange(e)}
              //   error={emailError}
                  //helperText={emailError ? "Enter a valid email address" : ""}
                  autoFocus 
                  />
              </Grid>
              <Grid>
                <Button
                  size="small"
                  onClick={()=>{handleConnectShopify()}}
                  startIcon={buttonLoading && <CircularProgress
                    style={{ }}
                    size={15}
                    color="secondary"
                />}
                  variant="contained"
                >
                  Connect Shopify
                </Button>
                </Grid>
                </Stack>
              </Paper>)}
          </div>
        );

      }
}

export default ThirdPartyIntegration;